import { Component, Input, OnInit } from '@angular/core';
import { EasymarineAiService } from '../../../easymarine-ai/easymarine-ai.service';

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [],
    template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent implements OnInit {
    // EasyMarine AI: o grupo só aparece se a tela existe no ambiente; o item Supervisão, só para supervisor, e o
    // Dashboards, só com eles ligados (quem decide é o backend, GET /me)
    constructor(public easymarineAi: EasymarineAiService) {}

    ngOnInit() {
        this.easymarineAi.iniciar();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts